export const API_BASE_URL = (process.env.REACT_APP_API || "https://localhost:7169/api").replace(/\/$/, "");

export function apiUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}

export function getPayload(response) {
  const data = response?.data;
  return data?.result ?? data?.data ?? data;
}
